import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=aab0b21e&scoped=true&"
import script from "./FAQ.js?vue&type=script&lang=js&"
export * from "./FAQ.js?vue&type=script&lang=js&"
import style0 from "./FAQ.scss?vue&type=style&index=0&id=aab0b21e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0b21e",
  null
  
)

export default component.exports